var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#2D3021"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4778 10.1955L24.4778 23.74H23.3491L23.3491 11.2564L9.86477 24.7408L9.06665 23.9426L22.8138 10.1955H9.80464V9.06677L23.3491 9.06677L24.4778 9.06677H24.4778V10.1955H24.4778Z",
    fill: "#DBFD6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerArrow);
export default __webpack_public_path__ + "static/media/partner-arrow.e4254ff094c616b6249cd3c3d2bfd999.svg";
export { ForwardRef as ReactComponent };